import type { StyleReferenceRecord } from "@/lib/catalog/types"

// StyleReferenceRecord carries two image identities:
// - reference.imageId is the encoded remote/catalog key used for reference APIs.
// - reference.imageInfo.imageId is the original local photo id used for project lookups.
export const toRemoteStyleReferenceImageId = (imageId: string) => encodeURIComponent(imageId)

export const toLocalPhotoIdFromStyleReferenceImageId = (imageId: string) => {
	try {
		return decodeURIComponent(imageId)
	} catch {
		return imageId
	}
}

export const findLocalPhotoIdForStyleReferenceImageId = (
	imageId: string,
	photos: Record<string, unknown>,
) => {
	if (photos[imageId] !== undefined) {
		return imageId
	}

	const localPhotoId = toLocalPhotoIdFromStyleReferenceImageId(imageId)
	if (localPhotoId !== imageId && photos[localPhotoId] !== undefined) {
		return localPhotoId
	}

	return undefined
}

export const getStyleReferenceRemoteImageId = (reference: StyleReferenceRecord) => {
	return toRemoteStyleReferenceImageId(reference.imageInfo.imageId)
}

export const findLocalPhotoIdForStyleReference = (
	reference: StyleReferenceRecord,
	photos: Record<string, unknown>,
) => {
	const imageInfoId = reference.imageInfo.imageId
	if (photos[imageInfoId] !== undefined) {
		return imageInfoId
	}

	return findLocalPhotoIdForStyleReferenceImageId(reference.imageId, photos)
}
